import { Space } from 'antd';
import styled from 'styled-components';

export const StyledReportCard = styled.div`
  padding: 16px 24px;
  border: 1px solid #f4f4f4;
  border-radius: 4px;
  width: 100%;
  .report-text {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    * {
      display: inline-block;
    }
  }
`;

export const StyledTitle = styled.div`
  padding-bottom: 16px;
  border-bottom: 1px solid #f4f4f4;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledReportCardContent = styled(Space)`
  padding-top: 20px;
  width: 100%;
`;
